import React from 'react';
import clsx from 'clsx';
import { ChipProps } from './types';
import { styles } from './styles';

export const Chip: React.FC<ChipProps> = ({
  children,
  variant = 'primary',
  size = 'sm',
  isActive = false,
  count,
  onClick,
  className,
}) => {
  const isInteractive = !!onClick;

  const variantStyle = isActive ? styles[`${variant}Active`] : styles[variant];

  const chipClasses = clsx(
    styles.base,
    styles[size],
    variantStyle,
    isInteractive && styles.interactive,
    className,
  );

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (onClick && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <span
      role={isInteractive ? 'button' : undefined}
      tabIndex={isInteractive ? 0 : undefined}
      onClick={onClick}
      onKeyDown={isInteractive ? handleKeyDown : undefined}
      className={chipClasses}>
      {children}
      {count !== undefined && count > 0 && (
        <span className={clsx(styles.count, isActive ? styles.countActive : styles.countDefault)}>
          ({count})
        </span>
      )}
    </span>
  );
};

export type { ChipProps, ChipVariant, ChipSize } from './types';
